import { render, staticRenderFns } from "./ButtonAddItem.vue?vue&type=template&id=84e23b98&scoped=true"
import script from "./ButtonAddItem.vue?vue&type=script&lang=js"
export * from "./ButtonAddItem.vue?vue&type=script&lang=js"
import style0 from "./ButtonAddItem.vue?vue&type=style&index=0&id=84e23b98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e23b98",
  null
  
)

export default component.exports